import { Controller } from "@hotwired/stimulus"

/*
 * This controller takes care of making sure to not
 * submit the payment form before we have a valid user input:
 * - Valid email address (if email target exists)
 * - User consent to our ToS
 */
export default class extends Controller {
  static targets = [
    "email",
    "panel",
    "check",
    "submitButton",
    "couponCode"
  ]

  connect() {
    // If the email address is prefilled, we want to validate it directly
    this.validateForm();

    // Each time a new form is rendered we dispatch a new event in order to let
    // the other components/controllers know and set specific values in the
    // submit form.
    this.dispatch("init");
  }

  validateForm() {
    if (this.validateEmail() && this.validateCheck()) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove("button--disabled");
    } else {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add("button--disabled");
    }
  }

  validateCheck() {
    return !!(this.checkTarget.checked);
  }

  validateEmail() {
    // Only check for a valid email address - if the email address target
    // is available - otherwise always return true. The wallet payment forms
    // (Apple Pay and Google Pay) don't need an email input.
    if (this.hasEmailTarget) {
      return this.validateFormat(this.emailTarget.value);
    }

    return true;
  }

  showError() {
    if (this.emailTarget.value && !this.validateFormat(this.emailTarget.value)) {
      this.emailTarget.classList.add("text-input--error")
    }
  }

  clearError() {
    this.emailTarget.classList.remove("text-input--error")
  }

  showPanel() {
    this.panelTarget.classList.remove("hidden")
  }

  hidePanel() {
    this.panelTarget.classList.add("hidden")
  }

  setCouponCode({ detail: { coupon_code } }) {
    this.couponCodeTarget.value = coupon_code;
  }

  validateFormat(email) {
    return email.match(
      /^$|^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }
}
